import React from 'react'
import BloomLandingPage from '../../components/BloomComp/BloomLandingComp/BloomLandingPage'
import BloomCollection from '../../components/BloomComp/BloomCollectionComp/BloomCollection'
import BloomCollectionlist from '../../components/BloomComp/BloomCollectionListComp/BloomCollectionlist'
import Footer from '../../components/HomeLandingComp/FooterComp/Footer'
import ContactForm from '../../components/HomeLandingComp/ContactFormComp/ContactForm'
import BloomQuoteSection from '../../components/BloomComp/BloomQuote/BloomQuoteSection '
import Bloomabout from '../../components/BloomComp/BloomAbout/Bloomabout'
import BloomSlider from '../../components/BloomComp/BloomSlider/BloomSliderSection'
import CardData from '../../components/BloomComp/BloomCardData/CardData'

const BloomlayoutPage = () => {
  return (
    <div>
    <BloomLandingPage />
    {/* <BloomCollection /> */}
    <Bloomabout />
    <BloomSlider />
    <BloomQuoteSection />
    <CardData />
    
    <ContactForm />
    <Footer />
    {/* <BloomCollectionlist/> */}
    </div>
  )
}

export default BloomlayoutPage